// ConsultantShareRow.jsx — 상담자배분 [배분 내역] 한 줄 (2026-10-06 창 → 탭으로 옮기며 ConsultantShareLedgerModal.jsx 에서 분리)
//   PC = 한 줄 칸 나눔 / 휴대폰(compact) = 카드. 적용·제외를 누르면 부모(onDecide)가 서버에 저장한다(요청 값 종전과 같음).
import React from 'react';
import { S } from './ConsultantShareLedgerModal.styles';
import { fmtMoney, fmtDate, fmtDateTime, statusLabel } from './ConsultantShareLedgerModal.helpers';

function DecisionButtons({ row, compact, saving, onDecide }) {
  return (
    <div style={S.actionRow(compact)}>
      <button
        type="button"
        style={S.actionBtn(row.decisionStatus !== 'excluded', false, compact)}
        disabled={saving}
        onClick={() => onDecide(row, 'included')}
      >
        적용
      </button>
      <button
        type="button"
        style={S.actionBtn(row.decisionStatus === 'excluded', true, compact)}
        disabled={saving}
        onClick={() => onDecide(row, 'excluded')}
      >
        제외
      </button>
    </div>
  );
}

export function ConsultantShareRow({ row, compact, memo, onMemo, saving, onDecide }) {
  const memoInput = (
    <input
      style={compact ? { ...S.memo, height: 40 } : { ...S.memo, marginTop: 7 }}
      value={memo ?? ''}
      placeholder="메모"
      aria-label={`${row.clientName || '계약'} 메모`}
      onChange={(event) => onMemo(row.contractId, event.target.value)}
    />
  );
  const decided = row.decidedByName ? `${row.decidedByName} · ${fmtDateTime(row.decidedAt)}` : '';

  if (compact) {
    return (
      <div style={S.row(true)}>
        <div style={S.mobileTop}>
          <div style={S.date}>{fmtDate(row.date)}</div>
          <span style={S.chip(row.decisionStatus)}>{statusLabel(row)}</span>
        </div>
        <div style={S.main}>
          <div style={S.mobileStore} title={row.clientName}>{row.clientName}</div>
          <div style={S.meta} title={row.contractItemsText}>{row.contractItemsText}</div>
        </div>
        <div style={S.mobilePeopleGrid}>
          <div style={S.mobileInfoBox}>
            <div style={S.infoLabel}>차감 영업자</div>
            <div style={S.infoValue}>{row.chargedMarketerName || '-'}</div>
          </div>
          <div style={S.mobileInfoBox}>
            <div style={S.infoLabel}>상담자</div>
            <div style={S.infoValue}>{row.consultantName || '-'}</div>
            <div style={S.infoHint}>{row.ownerMarketerName || '-'} 1:1 직원</div>
          </div>
        </div>
        <div style={S.mobileAmountBox}>
          <div>
            <div style={S.infoLabel}>배분금액</div>
            <div style={{ ...S.amount, textAlign: 'left' }}>{fmtMoney(row.shareAmount)}</div>
          </div>
          <div style={S.mobileCalc}>
            <div>{fmtMoney(row.baseNet)} × {Number(row.shareRate || 0).toLocaleString('ko-KR')}%</div>
            <div>매출 {fmtMoney(row.contractRevenue)} - 원가 {fmtMoney(row.contractCost)}</div>
          </div>
        </div>
        {memoInput}
        <DecisionButtons row={row} compact saving={saving} onDecide={onDecide} />
        {decided && <div style={S.calc}>{decided}</div>}
      </div>
    );
  }

  return (
    <div style={S.row(false)}>
      <div style={S.date}>{fmtDate(row.date)}</div>
      <div style={S.main}>
        <div style={S.store} title={row.clientName}>{row.clientName}</div>
        <div style={S.meta} title={row.contractItemsText}>{row.contractItemsText}</div>
      </div>
      <div style={S.main}>
        <div style={S.store}>{row.chargedMarketerName}</div>
        <div style={S.meta}>차감 대상 영업자</div>
      </div>
      <div style={S.main}>
        <div style={S.store}>{row.consultantName}</div>
        <div style={S.meta}>{row.ownerMarketerName} 1:1 직원</div>
      </div>
      <div>
        <div style={S.amount}>{fmtMoney(row.shareAmount)}</div>
        <div style={S.calc}>{fmtMoney(row.baseNet)} × {Number(row.shareRate || 0).toLocaleString('ko-KR')}%</div>
        <div style={S.calc}>매출 {fmtMoney(row.contractRevenue)} - 원가 {fmtMoney(row.contractCost)}</div>
      </div>
      <div>
        <span style={S.chip(row.decisionStatus)}>{statusLabel(row)}</span>
        {memoInput}
        <DecisionButtons row={row} compact={false} saving={saving} onDecide={onDecide} />
        {decided && <div style={{ ...S.calc, marginTop: 5 }}>{decided}</div>}
      </div>
    </div>
  );
}
